import { API_URL } from "../config/config"
import { patchRequest, postRequest } from "../utils/axiosUtils"

export const updateTag = async ({ id, tag, type }) => {
  if (!id || !tag || !type) {
    throw new Error('Missing id, tag, or type for tag update')
  }
  try {
    const response = await patchRequest({
      url: `${API_URL}/tag/update`,
      data: { id, tag, type },
      headers: {
        'Content-Type': 'application/json'
      },
    })
    if (response?.data?.success === false) {
      const customError = new Error(response.data.message || 'Tag update failed')
      customError.fieldErrors = response.data.errors || {}
      throw customError
    }
    return response.data
  } catch (err) {
    const responseData = err?.response?.data
    if (responseData) {
      const customError = new Error(responseData.message || 'Tag update failed')
      customError.fieldErrors = responseData.errors || {}
      throw customError
    }
    throw new Error(err.message || 'Unknown error occurred')
  }
}